/* musica.js — playlist por temporada, que NUNCA suena sola.

   Dos reglas duras que no son opinables:
   1) Los navegadores BLOQUEAN el audio hasta que hay un gesto del usuario. Por eso existe
      la puerta: el clic en «entrar con música» es ese gesto, y aquí solo se reacciona a él.
   2) WCAG 2.2 criterio 1.4.2 (nivel A): si el audio suena solo más de 3s, debe poder
      detenerse. Por eso el botón siempre está visible.

   Escalera de fuentes (cae sola, sin quedarse muda en silencio):
     playlist de la temporada  →  canción única  →  melodía generada (WebAudio, $0). */
(function () {
  var K = window.KAWAII || {};
  var M = K.musica || {};
  var boton = document.getElementById('boton-musica');
  if (!boton) return;

  var vol = M.volumen || 0.07;

  // ── sobrevivir al cambio de página (Shopify recarga el documento entero) ──
  var CLAVE = 'kawaii_musica';
  function recordado() {
    try { return JSON.parse(localStorage.getItem(CLAVE) || '{}'); } catch (e) { return {}; }
  }
  var previo = recordado();

  function barajar(a) {                           // Fisher-Yates
    for (var j = a.length - 1; j > 0; j--) {
      var k = Math.floor(Math.random() * (j + 1));
      var tmp = a[j]; a[j] = a[k]; a[k] = tmp;
    }
    return a;
  }

  var lista = (M.lista || []).filter(Boolean);
  if (!lista.length && M.archivo) lista = [M.archivo];

  if (M.aleatoria && lista.length > 1) {
    // El orden barajado se GUARDA y se reutiliza al navegar. Barajar otra vez en cada página
    // era el bug: la canción que sigue cambiaba al cambiar de página, y el índice guardado
    // apuntaba a una canción distinta de la que sonaba.
    var previas = lista.slice();
    var orden = (previo.orden || []).filter(function (u) { return previas.indexOf(u) > -1; });
    var nuevas = previas.filter(function (u) { return orden.indexOf(u) < 0; });
    lista = orden.concat(barajar(nuevas));        // lo que ya había conserva su orden
  }

  var audio = null, pista = 0, fallos = 0;

  // ── melodía generada: el último recurso, para no quedarse en silencio ────
  var ESCALAS = {
    kawaii: { s: [0, 2, 4, 7, 9, 12], t: 320 }, navidad: { s: [0, 4, 7, 11, 12, 16], t: 300 },
    halloween: { s: [0, 2, 3, 7, 8, 11], t: 365 }, verano: { s: [0, 2, 4, 7, 9, 14], t: 265 },
    sanvalentin: { s: [0, 3, 5, 7, 10, 12], t: 385 }
  };
  var PATRON = [0, 2, 4, 3, 5, 4, 2, 1];
  var ctx = null, temporizador = null, paso = 0;

  function nota(semitono, dur, ganancia) {
    var t = ctx.currentTime, osc = ctx.createOscillator(), g = ctx.createGain();
    osc.type = 'triangle';
    osc.frequency.value = 523.25 * Math.pow(2, semitono / 12);
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(ganancia, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    osc.connect(g); g.connect(ctx.destination);
    osc.start(t); osc.stop(t + dur + 0.06);
  }
  function latido() {
    var m = ESCALAS[K.temporada] || ESCALAS.kawaii;
    var semi = m.s[PATRON[paso % PATRON.length] % m.s.length];
    nota(semi, 0.55, vol); if (paso % 4 === 0) nota(semi - 24, 1.0, vol * 0.6);
    paso++;
  }
  function melodia() {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    ctx.resume(); clearInterval(temporizador); latido();
    temporizador = setInterval(latido, (ESCALAS[K.temporada] || ESCALAS.kawaii).t);
  }

  // ── la playlist ─────────────────────────────────────────────────────────
  function reproducir(i, desde) {
    if (!lista.length) { melodia(); return; }
    pista = ((i % lista.length) + lista.length) % lista.length;
    if (!audio) {
      audio = new Audio();
      audio.volume = Math.min(vol * 4, 1);
      audio.addEventListener('ended', function () { fallos = 0; reproducir(pista + 1, 0); });
      // Una pista que sí suena borra la cuenta: sin esto, fallos sueltos repartidos entre
      // canciones buenas acababan sumando y tirando todo a la melodía generada.
      audio.addEventListener('playing', function () { fallos = 0; });
      audio.addEventListener('error', function () {
        console.warn('[kawaii] no cargó la pista:', lista[pista]);
        fallos++;
        if (fallos >= lista.length) {   // ninguna carga: mejor la melodía que el silencio
          console.warn('[kawaii] ninguna canción se pudo cargar; uso la melodía generada');
          audio = null; lista = []; melodia(); return;
        }
        reproducir(pista + 1, 0);
      });
    }
    audio.src = lista[pista];
    if (desde > 0) {
      // Recién asignado el src no hay metadatos todavía, así que fijar currentTime aquí se
      // ignora sin avisar y la canción arranca desde el principio. Hay que esperar.
      var aplicar = function () {
        audio.removeEventListener('loadedmetadata', aplicar);
        try { if (desde < audio.duration) audio.currentTime = desde; } catch (e) { }
      };
      audio.addEventListener('loadedmetadata', aplicar);
    }
    audio.play().catch(function (e) {
      console.warn('[kawaii] el navegador aún no deja reproducir:', e && e.name);
    });
  }

  // El botón es un icono (o el SVG de Alfredo): el estado se marca con aria-pressed y CSS,
  // sin tocar su contenido — así el icono propio nunca se borra.
  function encender(desdePista, desdeSeg) {
    if (lista.length) reproducir(desdePista || 0, desdeSeg || 0); else melodia();
    boton.setAttribute('aria-pressed', 'true');
    recordar(true);
  }
  function apagar() {
    clearInterval(temporizador); temporizador = null;
    if (audio) audio.pause();
    boton.setAttribute('aria-pressed', 'false');
    recordar(false);
  }

  function recordar(on) {
    try {
      localStorage.setItem(CLAVE, JSON.stringify({
        on: on,
        // La IDENTIDAD de la canción, no su posición: el índice no significa lo mismo entre
        // una página y otra, la URL sí.
        url: lista[pista] || '',
        t: audio ? audio.currentTime : 0,
        orden: lista,
        ts: Date.now()
      }));
    } catch (e) { }
  }
  setInterval(function () {
    if (boton.getAttribute('aria-pressed') === 'true') recordar(true);
  }, 2000);

  boton.addEventListener('click', function () {
    (boton.getAttribute('aria-pressed') === 'true') ? apagar() : encender();
  });

  // La puerta (intro.js) llama a esto: ese clic ES el gesto que el navegador exige.
  window.kawaiiMusica = { encender: encender, apagar: apagar, pistas: lista.length };

  if (previo.on && !document.body.classList.contains('intro-corriendo')) {
    var i = previo.url ? lista.indexOf(previo.url) : -1;
    // Si la canción ya no está en la playlist (la quitaste desde el panel), se empieza de
    // cero: aplicarle el segundo guardado a OTRA canción es justo lo que se sentía roto.
    if (i < 0) encender(0, 0);
    else encender(i, previo.t || 0);
  }
})();
